var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"Unity"}},[_c('iframe',{ref:"makeInstance",attrs:{"id":"UnityFrame","src":_vm.unitySrc,"width":_vm.width,"height":_vm.height,"frameborder":"0","scrolling":"no","marginheight":"0","marginwidth":"0"}}),_c('div',{attrs:{"id":"UnityData","loginUser":_vm.loginUser,"modeName":"make"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }